import type { FAQItem } from './types';

export const vendorsFAQs: FAQItem[] = [
  {
    id: 'vendor-portal-overview',
    question: 'What do vendors get with the platform?',
    answer: `The vendor portal is designed to let approved vendors:

• Receive and respond to work orders
• Submit bids on larger projects
• Message residents/managers on each job
• Upload licenses, insurance, and work documentation
• Track payments and status

Boards would maintain an approved vendor list with ratings and credentials. This is planned functionality; the vendor portal does not persist data in the live product yet.`,
    category: 'vendors',
  },
  {
    id: 'vendor-onboarding-requirements',
    question: 'What do vendors need to onboard (documents, verification)?',
    answer: `The intended onboarding checklist for vendors:

• Business details and tax information (W-9/EIN)
• Proof of insurance and required licenses
• References or portfolio items (optional per category)
• Banking details via a payment processor for disbursements (processor integration not yet built)

Admins would be able to require approval before vendors can bid or accept jobs. This workflow is not yet built.`,
    category: 'vendors',
  },
  {
    id: 'multi-bid-support',
    question: 'Can we collect multiple bids and compare them?',
    answer: `This is planned functionality, not live today. For projects over a threshold you define, the design supports:

• Requesting bids from multiple approved vendors
• Vendors seeing scope and submitting estimates on the same timeline
• Comparing price, timeline, and references side-by-side
• Awarding the job in-platform and tracking progress to completion

An audit trail preserving every bid and decision is part of the design.`,
    category: 'vendors',
  },
  {
    id: 'preferred-vendor-program',
    question: 'Can we run a preferred vendor program?',
    answer: `A preferred vendor program is planned functionality. The design supports vendor tiers (Approved, Preferred) with:

• Minimum rating and on-time completion thresholds
• Insurance and license verifications kept current
• Faster assignment routing to Preferred vendors

This is not yet built.`,
    category: 'vendors',
  },
  {
    id: 'multi-community-bids',
    question: 'Can vendors bid across multiple communities at once?',
    answer: `Cross-community bundled bidding is a planned capability, not live today. The design supports vendors submitting **bundled bids** with tiered pricing:

• Shared scope with per-community line items
• Delivery and scheduling options per location
• Transparent comparison against single-community bids
• Final awards and settlements tracked per community

This depends on the vendor and settlement systems described elsewhere in this FAQ, none of which are built yet.`,
    category: 'vendors',
  },
  {
    id: 'vendor-payouts',
    question: 'How and when do vendors get paid?',
    answer: `Vendor payouts are planned functionality and are not live today. Once a payment processor is integrated, the design is for payments to be processed after **milestone approval**:

• Disbursements to vendor bank accounts via ACH per configured cadence
• Combined statements and **CSV exports** for reconciliation
• 1099 reporting would remain your responsibility; we would provide export files, not tax advice`,
    category: 'vendors',
  },
  {
    id: 'vendor-portal-detailed-overview',
    question: 'How does the vendor portal work?',
    answer: `The vendor portal is designed to streamline vendor interactions. This describes the intended experience; none of it persists data in the live product today.

**For Property Managers (planned):**
• Create vendor profiles with capabilities, insurance, contact info
• Send work orders directly through the system
• Track progress and receive status updates
• Manage vendor payments and invoicing

**For Vendors (planned):**
• Receive work orders with photos, descriptions, and priority levels
• Update job status and upload progress photos
• Submit invoices and track payments
• Build reputation through resident feedback

**For Residents (planned):**
• View approved vendor directory
• Track work order progress on their requests
• Provide feedback on completed work
• Rate vendor performance for future reference`,
    category: 'vendors',
  },
];
